import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const StyledBox = styled(Box)`
  overflow: scroll;
  padding-bottom: 60px;
`;